<template>
  <section class="page-wrapper">
    <transition name="fade-transform" mode="out-in">
      <router-view :key="key" />
    </transition>
  </section>
</template>

<script>
export default {
  name: "AppMain",
  data() {
    return {}
  },
  computed: {
    key() {
      return this.$route.path
    },
  },
}
</script>

<style lang="scss" scoped>
.page-wrapper {
  width: 100%;
  flex: 1;
  position: relative;
  overflow: hidden;
}
</style>

<style lang="scss">
// fix css style bug in open el-dialog
.el-popup-parent--hidden {
  .fixed-header {
    padding-right: 15px;
  }
}

.pageBreadcrumb {
  height: 46px;
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.12);
}

.el-breadcrumb {
  font-size: 12px !important;
  line-height: 46px !important;
  padding: 0 10px;
}

.page-container {
  height: 100%;
  overflow: hidden;
  display: flex;
  flex-direction: column;

  .page-breadcrumb {
    height: 46px;
    box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.12);
  }

  .page-main {
    padding: 20px;
    overflow-y: scroll;
    flex: 1;
  }
}
</style>
